import React, { useState } from 'react';
import { MapPin, Clock, Phone, Navigation, MessageSquare, MoreVertical, Car } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const TrackingScreen = ({ selectedService }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  
  // Mock service data
  const serviceInfo = {
    name: "Auto Vulcanizare Rapid",
    distance: "2.5 km",
    estimatedTime: "15 min",
    phone: "0722123456",
    currentLocation: "Str. Principală, nr. 24",
    status: "În drum spre locația ta"
  };

  return (
    <div className="fixed inset-0 bg-gray-50 overflow-hidden">
      {/* Menu Button */}
      <div className="absolute top-4 right-4 z-10">
        <button 
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="p-2 bg-white rounded-full shadow-md"
        >
          <MoreVertical className="w-6 h-6 text-gray-600" />
        </button>
        
        {/* Dropdown Menu */}
        {isMenuOpen && (
          <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-1">
            <button 
              className="w-full px-4 py-2 text-left text-red-600 hover:bg-gray-100"
              onClick={() => navigate('/')}
            >
              Anulează intervenția
            </button>
          </div>
        )}
      </div>

      {/* Map Section */}
      <div className="absolute inset-0 bg-gray-200">
        {/* Map Placeholder with markers */}
        <div className="relative w-full h-full">
          {/* Map Background */}
          <div className="absolute inset-0 bg-gray-200" />
          
          {/* User Position Marker */}
          <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <div className="relative">
              <div className="w-4 h-4 bg-blue-500 rounded-full" />
              <div className="absolute inset-0 bg-blue-500 rounded-full animate-ping opacity-75" />
            </div>
            <div className="mt-1 bg-white px-2 py-1 rounded-full text-xs font-medium shadow-md">
              Tu
            </div>
          </div>

          {/* Service Position Marker */}
          <div className="absolute left-1/3 top-1/3 transform -translate-x-1/2 -translate-y-1/2">
            <div className="relative">
              <div className="w-4 h-4 bg-green-500 rounded-full" />
              <div className="absolute inset-0 bg-green-500 rounded-full animate-ping opacity-75" />
            </div>
            <div className="mt-1 bg-white px-2 py-1 rounded-full text-xs font-medium shadow-md whitespace-nowrap">
              Vulcanizare Mobilă
            </div>
          </div>

          {/* Route Line Placeholder */}
          <svg className="absolute inset-0 w-full h-full">
            <path
              d="M200,200 L400,300"
              stroke="#4F46E5"
              strokeWidth="3"
              strokeDasharray="6 6"
              fill="none"
            />
          </svg>
        </div>
      </div>

      {/* Fixed Bottom Info Panel */}
      <div className="fixed bottom-0 left-0 right-0 bg-white rounded-t-xl shadow-lg h-64">
        {/* Service Info */}
        <div className="p-4">
          <div className="flex items-start gap-4 mb-4">
            <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center">
              <Car className="w-6 h-6 text-gray-600" />
            </div>
            <div className="flex-grow">
              <h3 className="font-semibold text-lg text-gray-900">
                {serviceInfo.name}
              </h3>
              <p className="text-green-600 font-medium">
                {serviceInfo.status}
              </p>
            </div>
          </div>

          {/* Quick Stats */}
          <div className="grid grid-cols-2 gap-4 mb-4">
            <div className="bg-gray-50 rounded-lg p-3">
              <div className="flex items-center text-gray-600">
                <Navigation className="w-4 h-4 mr-2" />
                Distanță
              </div>
              <div className="text-lg font-semibold mt-1">
                {serviceInfo.distance}
              </div>
            </div>
            <div className="bg-gray-50 rounded-lg p-3">
              <div className="flex items-center text-gray-600">
                <Clock className="w-4 h-4 mr-2" />
                Timp Estimat
              </div>
              <div className="text-lg font-semibold mt-1">
                {serviceInfo.estimatedTime}
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="grid grid-cols-2 gap-4">
            <button 
              className="flex items-center justify-center gap-2 bg-blue-600 text-white py-3 px-4 rounded-lg font-medium hover:bg-blue-700"
            >
              <Phone className="w-5 h-5" />
              Sună
            </button>
            <button 
              className="flex items-center justify-center gap-2 bg-gray-100 text-gray-700 py-3 px-4 rounded-lg font-medium hover:bg-gray-200"
            >
              <MessageSquare className="w-5 h-5" />
              Mesaj
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrackingScreen;